import React from 'react'
import Card from 'organization/Event/Services/Apps/Card'
import obieLogo from 'organization/Event/Services/Apps/Obie/logo.png'
import {useEventRoutes} from 'organization/Event/EventRoutes'
import {OBIE} from 'organization/Event/Services/ServicesProvider'

export default function ObieCard() {
  const routes = useEventRoutes()

  return (
    <Card
      service={OBIE}
      label="Obie"
      link={routes.services.obie}
      logo={obieLogo}
      color="#FFFFFF"
    />
  )
}
